import * as React from "react";

import { useDefaultIngestionRules } from "@/shared/domain/ingestionRules/hooks";

/**
 * The defaults sign-up offers (those for new orgs) and the names picked among
 * them. `picked` is undefined until the defaults load, then every offered name
 * until the user changes the selection.
 */
export function usePickedDefaultRules(orgId: string) {
  const defaults = useDefaultIngestionRules(orgId);
  const [edited, setEdited] = React.useState<string[]>();
  const rules = React.useMemo(
    () => defaults.data?.filter((rule) => rule.for_new_orgs),
    [defaults.data],
  );
  const picked = edited ?? rules?.map((rule) => rule.name);
  return { rules, isLoading: defaults.isLoading, picked, setPicked: setEdited };
}
